/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import './index.css';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import scrollToTop from '../../utils/scrollToTop';
import setTitle from '../../utils/setTitle';
import Step from '../step';
import Info from '../step/info';
import history from '../../routes/history';
import SelectType from './selectType';
import Checkbox from './checkbox';
import {Link} from 'react-router-dom';
import classNames from 'classname';
import {acceptProtocol, updateFormInput, updateAddress, toOrder} from '../../actions/step';
import {getToOrderData} from '../../reducers/step';
import Address from '../lib/address';
import Button from '../lib/button'
import FormRow from './formRow';
import Loading from '../common/loading';
import {setisLoading} from '../../actions/app';

class Step2 extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  };
  state = {
    isLoading: false
  }
  rules = {
    name: [{
      regExp: /^.{1,15}$/,
      info: '请输入姓名'
    }],
    phone: [{
      regExp: /^1\d{10}$/,
      info: '请输入正确的手机号码'
    }],
    detail: [{
      regExp: /^.{3,50}$/,
      info: '请填写详细地址信息'
    }]
  };
  constructor(props) {
    super(props);
    const { options, match, setisLoading } = this.props;
    scrollToTop();
    setisLoading(false);
    setTitle('填写联系人');
    if (!options.id) {
      history.push(`/view/appraisal/${match.params.pid}/step1`)
    }
  }
  handleSubmit = () => {
    const { expressInfo: { unLock }, toOrder, options } = this.props;
    if (!unLock || (options.supplierId === 1 && options.inquiryPrice < 50)) {
      return false;
    }
    this.props.setisLoading(true);
    const state = this.context.store.getState();
    const data = getToOrderData(state.step);
    toOrder(data);
  };
  render () {
    const {
      acceptProtocol, updateFormInput, updateAddress, isLoading, options,
      expressInfo: { accept, unLock, pickupType, streetId }
    } = this.props;
    const contentCls = classNames('mcycle-express-content', {
      'type1': pickupType === 1,
      'type2': pickupType === 0
    });
    const isEffect = !(options.supplierId === 1 && options.inquiryPrice < 50);
    return (
      <Step step={2}>
        <Info {...this.props.options} selected={true} />
        <div className="mcycle-step-express">
          <SelectType />
          <div className={contentCls}>
            <FormRow title="姓名" placeholder="长度不超过15个汉字" rules={this.rules.name}
                     onChange={value => updateFormInput('name', value)} maxLength={15} />
            <FormRow title="手机号" placeholder="请输入11位手机号" rules={this.rules.phone}
                     onChange={value => updateFormInput('phone', value)} maxLength={11} />
            <FormRow title="我的地址" placeholder="请输入11位手机号" info={streetId === null ? '请选择完整地址' : ''}>
              <Address onChange={(name, id, type, data) => updateAddress(data)} />
            </FormRow>
            <FormRow title="详细地址" rules={this.rules.detail}
                     placeholder="请输入3-50个汉字的详细地址，如路名、门牌号"
                     className="mcycle-express-content-address"
                     maxLength={50} onChange={value => updateFormInput('detail', value)} />
          </div>
          <div className="mcycle-express-bottom">
            <div className="mcycle-protocol">
              <Checkbox onClick={acceptProtocol} checked={accept} label="我已查看并接受" />
              <Link to="/view/protocol" target="_blank" className="mcycle-protocol-link">
                回购协议 >
              </Link>
            </div>
            <Button type={unLock && isEffect ? 'primary' : 'disabled'} size="large" onClick={this.handleSubmit}>提交</Button>
          </div>
          <Loading isLoading={isLoading} />
        </div>
      </Step>
    )
  }
}

export default connect(
  state => ({
    isLoading: state.app.isLoading,
    options: state.step.options,
    expressInfo: state.step.expressInfo
  }),
  {
    acceptProtocol,
    updateFormInput,
    updateAddress,
    toOrder,
    setisLoading
  }
)(Step2);



// WEBPACK FOOTER //
// ./src/components/step2/index.js